// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1685":"f583d77bf5ece6b7","2834":"d491f28d3666045b","8016":"1467f6ec4eecd627","9175":"e7bfa2e48c199ddb","9435":"cb237d41bd484cc6"}[chunkId] + ".js";
};